import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import { GridCellParams } from "@mui/x-data-grid";

export default function CheckCell(props: GridCellParams<any, any>) {
    if (props.value === true)
        return <CheckIcon />
    else if (props.value === false)
        return <CancelIcon />
    return <></>
}